import { UserClaim } from '@/constants/userClaim';
import { RouteName } from '../constants/routeNames';
import { reportDetailRoutes } from './reportDetailRoutes';

export const reportRoutes = (t: (key: string) => string) => [
  {
    path: '/create-report/:reportType',
    name: RouteName.CreateReport,
    component: () => import('../../views/CreateReport.vue'),
    meta: {
      requiresAuth: true,
      claims: [UserClaim.Claim_Admin, UserClaim.Claim_Report_Create],
      title: t('sidebar.createReport')
    }
  },
  {
    path: '/reports/active/:reportsType',
    name: RouteName.ActiveReports,
    component: () => import('../../views/ReportsPage.vue'),
    meta: {
      requiresAuth: true,
      claims: [
        UserClaim.Claim_Admin,
        UserClaim.Claim_Report_Review,
        UserClaim.Claim_Report_Review_All,
        UserClaim.Claim_Report_Economy_Review_All
      ],
      key: 'activeReports',
      title: t('sidebar.activeReports')
    }
  },
  {
    path: '/reports/historic/:reportsType',
    name: RouteName.HistoricReports,
    component: () => import('../../views/ReportsPage.vue'),
    meta: {

      requiresAuth: true,
      claims: [
        UserClaim.Claim_Admin,
        UserClaim.Claim_Report_Review,
        UserClaim.Claim_Report_Review_All,
        UserClaim.Claim_Report_Economy_Review_All
      ],
      key: 'historicReports',
      title: t('sidebar.historicalReports')
    }
  },
  {
    path: '/reports/:reportName/',
    name: RouteName.ReportPage,
    component: () => import('../../views/report-details/ReportPage.vue'),
    children: reportDetailRoutes,
    meta: {
      requiresAuth: true,
      sidebarValue: 'financial-reports',
      claims: [
        UserClaim.Claim_Admin,
        UserClaim.Claim_Report_Review,
        UserClaim.Claim_Report_Review_All,
        UserClaim.Claim_Report_Economy_Review_All
      ],
      title: t('general.reportDetails')
    }
  }
];
